import { projectStagesDe } from 'define/calculator';

export const getDefaultConfigDe = type => ({
  id: `calculator-${type}`,
  formName: `price-${type}`,
  title: 'Fordern Sie ein vorteilhaftes Angebot für Ihre kundenspezifische Lösung an',
  counter: false,
  sections: [
    {
      name: 'development_direction',
      type: 'development_direction',
      blockType: 'checkbox',
      counterType: 'checkbox',
      shouldShowHints: true,
      defaultValue: false,
      title: 'Welcher Typ von Softwarelösung würden Sie zusammen mit Andersen entwickeln?',
      mobileTitles: {
        default: 'Software-Typ',
        active: 'Software-Typ',
        section: 'Software-Typ',
      },
      items: ['Web', 'Mobile', 'Beratungsbedarf'],
      accordion: true,
      fullWidth: false,
      cols: { xl: { cols: 2 }, lg: { cols: 1 }, md: { cols: 1 } },
    },
    {
      name: 'stage',
      type: 'stage',
      blockType: 'radioButton',
      counterType: 'radio',
      totalBoxType: 'string',
      defaultValue: false,
      title: 'Was ist die aktuelle Phase Ihres Softwareentwicklungsprozesses?',
      mobileTitles: {
        default: 'Ihre aktuelle Projektphase',
        active: 'Ihre aktuelle Projektphase',
        section: 'Ihre aktuelle Projektphase',
      },
      items: projectStagesDe,
      accordion: true,
      fullWidth: false,
      cols: { xl: { cols: 2 }, lg: { cols: 2 }, md: { cols: 2 } },
    },
    {
      name: 'professional_consultation',
      type: 'team',
      blockType: 'checkbox',
      counterType: 'checkbox',
      defaultValue: false,
      title: 'Benötigen Sie professionelle Beratung von unseren Experten?',
      mobileTitles: {
        default: 'Expertenberatung',
        active: 'Expertenberatung',
        section: 'Expertenberatung',
      },
      items: ['Projektmanager', 'Business Analyst', 'UI/UX Designer', 'Architekt'],
      accordion: true,
      withMT: true,
      borderBottom: false,
    },
    {
      name: 'duration',
      type: 'duration',
      blockType: 'rangeSlider',
      counterType: 'range',
      totalBoxType: 'range',
      defaultValue: false,
      initialStep: 1,
      title: 'Geben Sie voraussichtliche Dauer von Ihrem Projekt an',
      mobileTitles: {
        default: 'Projektdauer',
        active: 'Projektdauer',
        section: 'Projektdauer',
      },
      items: [
        '1 Monat',
        '2 Monate',
        '3 Monate',
        '4 Monate',
        '5 Monate',
        '6 Monate',
        '7 Monate',
        '8 Monate',
        '9 Monate',
        '10 Monate',
        '11 Monate',
        '12 Monate',
        '13 Monate',
        '14 Monate',
        '15 Monate',
        '16 Monate',
        '17 Monate',
        '18 Monate',
        '19 Monate',
        '20 Monate',
        '21 Monate',
        '22 Monate',
        '23 Monate',
        '24 Monate',
      ],
      accordion: true,
      borderBottom: false,
    },
  ],
});
